/**
 * Pure Utility Helpers for Dance Music Player
 */

export function formatTime(secs: number): string {
    if (isNaN(secs) || secs < 0) return '0:00';
    const m = Math.floor(secs / 60);
    const s = Math.floor(secs % 60);
    return `${m}:${s < 10 ? '0' : ''}${s}`;
}

export function formatFileSize(bytes: number): string {
    if (!bytes) return '';
    const mb = (bytes / (1024 * 1024)).toFixed(1);
    return `${mb} MB`;
}

export function escapeHtml(value: string): string {
    return value.replace(/[&<>'"]/g, character => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
    })[character] || character);
}

export type ToastKind = 'info' | 'success' | 'warning';

const toastTimers = new Map<string, number>();

export function showToast(message: string, kind: ToastKind = 'info', key?: string): void {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const existingToast = key
        ? container.querySelector<HTMLElement>('.toast[data-toast-key="' + CSS.escape(key) + '"]')
        : null;
    const toast = existingToast || document.createElement('div');
    toast.className = 'toast toast-' + kind;
    if (key) toast.dataset.toastKey = key;
    toast.replaceChildren();

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('width', '18');
    icon.setAttribute('height', '18');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '2');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('aria-hidden', 'true');

    const iconMarkup = kind === 'success'
        ? '<path d="m5 12 4 4L19 6" />'
        : kind === 'warning'
            ? '<path d="M10.3 3.7 2.2 18a2 2 0 0 0 1.7 3h16.2a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0Z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />'
            : '<circle cx="12" cy="12" r="9" /><line x1="12" y1="11" x2="12" y2="16" /><line x1="12" y1="8" x2="12.01" y2="8" />';
    icon.innerHTML = iconMarkup;

    const label = document.createElement('span');
    label.textContent = message;
    toast.append(icon, label);
    if (!existingToast) container.appendChild(toast);

    toast.style.animation = 'none';
    void toast.offsetWidth;
    toast.style.animation = '';

    if (key) {
        const existingTimer = toastTimers.get(key);
        if (existingTimer !== undefined) window.clearTimeout(existingTimer);
    }

    const timer = window.setTimeout(() => {
        if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
        }
        if (key) toastTimers.delete(key);
    }, 2500);
    if (key) toastTimers.set(key, timer);
}
